<cm-image-viewer
  [images]="message.images"
  [currentImage]="0"
  (backPressed)="onBackPressed($event)"
></cm-image-viewer>
